const colourGradientor = (
  p: number,
  rgbBeginning: number[],
  rgbEnd: number[],
) => {
  const w = p * 2 - 1;
  const w1 = (w + 1) / 2.0;
  const w2 = 1 - w1;
  const rgb = [
    Math.trunc(rgbBeginning[0] * w1 + rgbEnd[0] * w2),
    Math.trunc(rgbBeginning[1] * w1 + rgbEnd[1] * w2),
    Math.trunc(rgbBeginning[2] * w1 + rgbEnd[2] * w2),
  ];

  return rgb;
};

const componentToHex = (c: number) => {
  const hex = c.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
};

const rgbToHex = (r: number, g: number, b: number) => {
  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
};

const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ]
    : [];
};

const getColorCell = (
  curval: number | null | undefined,
  hexStart: string | undefined,
  hexEnd: string | undefined,
  colorStyle: 'greentored' | 'roygbiv' = 'greentored',
): string => {
  if (!curval || typeof curval !== 'number') return '#ffffff';

  hexStart = hexStart || '#AFDCFD';
  hexEnd = hexEnd || '#279CF8';

  const percentage = Math.round(curval * 100) / 100;

  if (percentage > 100) return hexStart;

  const mn = 0;
  const mx = 100;

  const position = (percentage - mn) / (mx - mn);

  const shft =
    colorStyle === 'roygbiv'
      ? 0.5 * position + 1.7 * (1 - position)
      : position + 0.2 + 5.5 * (1 - position);

  const period = 2 * Math.PI;

  let x = shft + position * period;

  x = colorStyle !== 'roygbiv' ? -x : x;

  x = percentage / mx;
  const rgb = colourGradientor(x, hexToRgb(hexStart), hexToRgb(hexEnd));

  return rgbToHex(rgb[0], rgb[1], rgb[2]);
};

export default getColorCell;
